import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { loading, alert, toFixed, getStorage, replaceText, roundToTwo } from "./CustomComponent.js";

import "../assets/css/bootstrap.css";
import "./global.js";

// เรียกปิด loading ทันทีตั้งแต่เข้ามาโหลดหน้า/ไฟล์นี้
loading(false);

pdfMake.vfs = pdfFonts.pdfMake.vfs;
pdfMake.fonts = {
  FCIconic: { normal: "FCIconic-Light.ttf", bold: "FCIconic-Bold.ttf", italics: "FCIconic-Italic.ttf", bolditalics: "FCIconic-Italic.ttf" },
  THSarabunNew: { normal: "THSarabunNew.ttf", bold: "THSarabunNew-Bold.ttf", italics: "THSarabunNew-Italic.ttf", bolditalics: "THSarabunNew-BoldItalic.ttf" },
  Roboto: { normal: "Roboto-Regular.ttf", bold: "Roboto-Medium.ttf", italics: "Roboto-Italic.ttf", bolditalics: "Roboto-MediumItalic.ttf" },
};

async function print(docDefinition) {
  pdfMake.createPdf(docDefinition).print();
}

async function open(docDefinition, filename = "รายงาน.pdf") {
  try {
    pdfMake.createPdf(docDefinition).open();
  } catch (error) {
    pdfMake.createPdf(docDefinition).download(filename);
    if (error === "Open PDF in new window blocked by browser") {
      alert("warning", "แจ้งเตือน", "ไม่สามารถเปิดเอกสารได้เนื่องจากการปิดกั้นจากบราวเซอร์");
    } else {
      alert("warning", "แจ้งเตือน", "กรุณาลองใหม่อีกครั้ง");
    }
  }
}

// รายงานลูกค้าห้องว่าง
async function report_customer_3(data, common_expenses, equipment_maintenance_fee, common_expenses_type) {
  loading(true); // เปิด loading เริ่มประมวลผล PDF

  // คำนวณค่าที่ซ้ำๆ ไว้รอบเดียว (ลดภาระใน loop)
  // ค่าส่วนกลางของห้องหนึ่ง — common_expenses_type = 1 คือคิดตามขนาดห้อง (ตร.ม.)
  // NOTE เดิมใช้อัตราดิบทุกห้องแล้วคูณจำนวนห้อง ทำให้โครงการที่คิดตาม ตร.ม. ยอดผิดทั้งคอลัมน์และยอดรวม
  const roomExpense = (item) => (!common_expenses_type ? (common_expenses || 0) : roundToTwo((item.room_size || 0) * (common_expenses || 0)));
  const eqMaintText = equipment_maintenance_fee ? toFixed(equipment_maintenance_fee) : "0.00";
  const totalCommonExp = toFixed(data.reduce((sum, item) => sum + roomExpense(item), 0));
  const totalEqMaint = toFixed((equipment_maintenance_fee || 0) * data.length);
  const projectName = getStorage("project_name") || "";

  let array = data.map((item, index) => [
    { text: index + 1, alignment: "center" },
    { text: item.building || "-", alignment: "center" },
    { text: item.address_number || "-", alignment: "center" },
    { text: item.full_name || "-", alignment: "left" },
    { text: item.room_size ? `${item.room_size} ตร.ม.` : "-", alignment: "right" },
    { text: toFixed(roomExpense(item)), alignment: "right" },
    { text: eqMaintText, alignment: "right" },
    { text: "-", alignment: "left" },
  ]);

  const docDefinition = {
    content: [
      { text: "รายงานห้องว่าง", alignment: "center", fontSize: 16, bold: true },
      { text: projectName, alignment: "center", fontSize: 16, bold: true },
      { text: " " },
      {
        columns: [
          { text: `รวมเงินค่าส่วนกลางห้องชุดว่าง กรรมสิทธิ์ ${projectName} เป็นเงินทั้งสิ้น ${totalCommonExp} บาท`, alignment: "left" },
          { text: `ค่าบริการอุปกรณ์ เป็นเงินทั้งสิ้น ${totalEqMaint} บาท`, alignment: "right" },
        ],
      },
      { text: " " },
      {
        table: {
          headerRows: 1,
          widths: ["6%", "7%", "9%", "23%", "12%", "13%", "18%", "12%"],
          body: [
            [
              { text: "ลำดับ", alignment: "center" },
              { text: "อาคาร", alignment: "center" },
              { text: "บ้านเลขที่", alignment: "center" },
              { text: "ชื่อ - สกุล", alignment: "center" },
              { text: "ขนาดห้องชุด", alignment: "center" },
              { text: "ค่าส่วนกลาง", alignment: "center" },
              { text: "ค่าบริการอุปกรณ์ฯ", alignment: "center" },
              { text: "หมายเหตุ", alignment: "center" },
            ],
            ...array,
          ],
        },
      },
    ],
    defaultStyle: { font: "THSarabunNew", fontSize: 14, lineHeight: 0.9 },
    pageSize: "A4",
    pageMargins: [15, 15, 15, 15],
  };

  let textDocDefinition = await replaceText(docDefinition);
  
  loading(false); // ปิด loading เมื่อสร้างเสร็จพร้อมเปิดเอกสาร
  
  open(textDocDefinition, `รายงานห้องว่าง ${new Date().toISOString()}.pdf`);
}

export { report_customer_3 };